import styled from 'styled-components';

export const TagWrapper = styled.div`
  display: flex;
`;
